module.exports = __webpack_public_path__ + "7f0af72beb58afe27c30912c05056bc4.MP3";